import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CsmErrorService {

  constructor(private _httpClient: HttpClient) { }

  getCsmErrors(guid): Observable<any> {
    return this._httpClient.get<string[]>(`${environment.apiUrl}/csmerror?errorGuid=${guid}`);
  }

}
